import { GetCarServicesParams } from './types';

const BASE_KEY = 'CAR_SERVICES';

export const carServiceKeys = {
  all: () => [BASE_KEY],
  list: (params: GetCarServicesParams) => [BASE_KEY, params],
};
